
// 获取获取商品列表(学费和豆豆)
export const PAYMENT_GET_GOODS = 'PAYMENT_GET_GOODS';
export const PAYMENT_SET_GOODS = 'PAYMENT_SET_GOODS';
/* eslint-disable */
// 发起支付
export const PAYMENT_READY_INfO = 'PAYMENT_READY_INfO';

// 小程序订单金额获取
export const SMALLROUTINE_AMOUNT_GET = 'SMALLROUTINE_AMOUNT_GET';

// 课时包支付
export const PAYMENT_PACKAGE_GOOD = 'PAYMENT_PACKAGE_GOOD';




// WEBPACK FOOTER //
// ./src/views/index/store/types/types_payment.js